import { observer } from "mobx-react-lite";

const VideoTab = ({ video_url, main_text }) => {
  const getStrings = (value) => {
    if (!value) return "";
    if (typeof value === "string") return value;
    if (typeof value === "object" && value?.en) return value.en;
    return "";
  };

  // Extract URL string even if it's an object
  const url = getStrings(video_url);
  const hasIframe = url.indexOf("<iframe") === 0;

  return (
    <div className="flex flex-col gap-8">
      {" "}
      {/* className="flex flex-col gap-8 lg:flex-row" */}
      <div
        className="wysiwyg max-md:px-5"
        dangerouslySetInnerHTML={{ __html: getStrings(main_text) }}
      />
      {url ? (
        hasIframe ? (
          <div dangerouslySetInnerHTML={{ __html: url }} />
        ) : (
          <iframe
            src={url}
            title="Instructional video"
            className="h-96 w-full lg:w-2/3"
          />
        )
      ) : (
        <></>
      )}
    </div>
  );
};

export default observer(VideoTab);
